/**
 * Toasts — for things that happen *to* the tester (a phone taken over, a build refused) rather than
 * state they are looking at. A tiny module-level store instead of context: any module can call
 * `toast()` without threading a hook through stream objects.
 */

import { Info, TriangleAlert } from 'lucide-react'
import { useEffect, useState } from 'react'

export interface Toast {
  id: number
  text: string
  kind?: 'bad'
}

let nextId = 1
let items: Toast[] = []
const listeners = new Set<(t: Toast[]) => void>()

function publish() {
  for (const l of listeners) l(items)
}

export function toast(text: string, kind?: 'bad', ttlMs = 6000): void {
  const item: Toast = { id: nextId++, text, ...(kind ? { kind } : {}) }
  items = [...items, item]
  publish()
  setTimeout(() => {
    items = items.filter((i) => i.id !== item.id)
    publish()
  }, ttlMs)
}

export function Toasts() {
  const [list, setList] = useState<Toast[]>(items)

  useEffect(() => {
    listeners.add(setList)
    return () => {
      listeners.delete(setList)
    }
  }, [])

  if (!list.length) return null
  return (
    <div className="toasts" role="status" aria-live="polite">
      {list.map((t) => (
        <div key={t.id} className={`toast${t.kind ? ` ${t.kind}` : ''}`}>
          <span>{t.kind === 'bad' ? <TriangleAlert className="ico" size={16} aria-hidden /> : <Info className="ico" size={16} aria-hidden />}</span>
          <span>{t.text}</span>
        </div>
      ))}
    </div>
  )
}
